// This code enables to write simple compilers (see folder compilers).
// Each defined compiler will be called whenever its selector is found in the dom.
// See https://makandracards.com/makandra/503891-unobtrusive-javascript-helper-to-progressively-enhance-html

(function() {
  const compilersBySelector = {}
  const CLEANABLE_CLASS = 'cleanable'
  const CLEANABLE_SELECTOR = '.' + CLEANABLE_CLASS

  window.addEventListener('DOMContentLoaded', function() {
    let root = document.documentElement
    compileSubtree(root)
    watchForNewElements(root)
  })

  function subtree(root, selector) {
    const matches = []
    if (root.matches(selector)) {
      matches.push(root)
    }
    matches.push(...root.querySelectorAll(selector))
    return matches
  }

  function compileSubtree(root) {
    for (let selector in compilersBySelector) {
      let compiler = compilersBySelector[selector]
      subtree(root, selector).forEach((match) => compileElement(match, compiler))
    }
  }

  function cleanSubtree(root) {
    subtree(root, CLEANABLE_SELECTOR).forEach((cleanable) => {
      cleanable._cleaner()
      delete cleanable._cleaner
      cleanable.classList.remove(CLEANABLE_CLASS)
    })
  }

  function compileElement(element, compiler) {
    const result = compiler(element)
    if (typeof result === 'function') {
      element._cleaner = result
      element.classList.add(CLEANABLE_CLASS)
    }
  }

  function eachElement(nodeList, fn) {
    nodeList.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        fn(node)
      }
    })
  }

  function onMutated(mutations) {
    mutations.forEach((mutation) => {
      eachElement(mutation.removedNodes, cleanSubtree)
      eachElement(mutation.addedNodes, compileSubtree)
    })
  }

  function watchForNewElements(root) {
    const observer = new MutationObserver(onMutated)
    observer.observe(root, { childList: true, subtree: true })
  }

  window.compiler = function(selector, fn) {
    compilersBySelector[selector] = fn
  }
})()
